function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { lookupChannelUser } from '@/actions/ChannelActions';
import { serializeProviderUserId } from '@/utils/user';
import { useIntl } from 'react-intl';
import dayjs from 'dayjs';
import { LordIconSizes } from '@/types/client';
import styles from './GiveawayWinnerModal.module.scss';
import Confetti from 'react-confetti';
import { SocketContext } from '../providers/SocketProvider';
import useIntlMemo from '@/hooks/useIntlMemo';
import Modal from '../Modal';
import { Avatar, Divider, Loader, parseThemeColor, Text, Title, Tooltip, useMantineTheme } from '@mantine/core';
import classNames from 'classnames';
import { useElementSize } from '@mantine/hooks';
import EmptyState from '../EmptyState';
var MemoizedConfetti = /*#__PURE__*/ React.memo(Confetti, function(prevProps, nextProps) {
    return prevProps.width === nextProps.width && prevProps.height === nextProps.height && prevProps.colors === nextProps.colors && prevProps.recycle === nextProps.recycle;
});
function GiveawayWinnerModal(_param) {
    var onClose = _param.onClose, winner = _param.winner, channel = _param.channel, _param_priorMessages = _param.priorMessages, priorMessages = _param_priorMessages === void 0 ? [] : _param_priorMessages, props = _object_without_properties(_param, [
        "onClose",
        "winner",
        "channel",
        "priorMessages"
    ]);
    var intl = useIntl();
    var _React_useState = _sliced_to_array(React.useState(null), 2), user = _React_useState[0], setUser = _React_useState[1];
    var _React_useState1 = _sliced_to_array(React.useState([]), 2), messages = _React_useState1[0], setMessages = _React_useState1[1];
    var socketClient = React.useContext(SocketContext);
    var _React_useState2 = _sliced_to_array(React.useState(0), 2), stopwatch = _React_useState2[0], setStopwatch = _React_useState2[1];
    var theme = useMantineTheme();
    var _useElementSize = useElementSize(), ref = _useElementSize.ref, width = _useElementSize.width, height = _useElementSize.height;
    var colors = React.useMemo(function() {
        var _parseThemeColor = parseThemeColor({
            color: 'red.4',
            theme: theme
        }), red = _parseThemeColor.value;
        var _parseThemeColor1 = parseThemeColor({
            color: 'orange.4',
            theme: theme
        }), orange = _parseThemeColor1.value;
        var _parseThemeColor2 = parseThemeColor({
            color: 'yellow.4',
            theme: theme
        }), yellow = _parseThemeColor2.value;
        var _parseThemeColor3 = parseThemeColor({
            color: 'green.4',
            theme: theme
        }), green = _parseThemeColor3.value;
        var _parseThemeColor4 = parseThemeColor({
            color: 'blue.4',
            theme: theme
        }), blue = _parseThemeColor4.value;
        return [
            red,
            orange,
            yellow,
            green,
            blue
        ];
    }, [
        theme
    ]);
    React.useEffect(function() {
        if (channel == null || winner == null) {
            return;
        }
        setMessages([]);
        setUser(null);
        lookupChannelUser(channel._id, winner.name).then(function(data) {
            return setUser(data);
        }).catch(function(error) {
            return console.error(error);
        });
    }, [
        winner,
        channel
    ]);
    var winnerIsActive = (messages === null || messages === void 0 ? void 0 : messages.length) > 0;
    React.useEffect(function() {
        if (winner == null || winnerIsActive) {
            return;
        }
        setStopwatch(0);
        var interval = setInterval(function() {
            setStopwatch(function(prev) {
                return prev + 1;
            });
        }, 1000);
        return function() {
            return clearInterval(interval);
        };
    }, [
        winner,
        winnerIsActive
    ]);
    React.useEffect(function() {
        var handleChatMessage = function handleChatMessage(payload) {
            var user = payload.user;
            if (winner == null || serializeProviderUserId(user) !== serializeProviderUserId(winner)) {
                return;
            }
            setMessages(function(prev) {
                return [
                    payload
                ].concat(_to_consumable_array(prev));
            });
        };
        if (socketClient == null || winner == null || channel == null) {
            return;
        }
        socketClient.on('chatMessage', handleChatMessage);
        return function() {
            socketClient.off('chatMessage', handleChatMessage);
        };
    }, [
        channel,
        socketClient,
        winner
    ]);
    var followingStatus = useIntlMemo(function(intl) {
        if ((user === null || user === void 0 ? void 0 : user.following) == null) {
            return intl.formatMessage({
                id: "yx3ldI",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Following Status Unknown"
                    }
                ]
            });
        }
        var date = dayjs(user.following);
        if (date.valueOf() === 0) {
            return intl.formatMessage({
                id: "HsHCNl",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Not Followed"
                    }
                ]
            });
        }
        return intl.formatMessage({
            id: "B7E5fT",
            defaultMessage: [
                {
                    type: 0,
                    value: "Followed "
                },
                {
                    type: 1,
                    value: "date"
                }
            ]
        }, {
            date: date.fromNow()
        });
    }, [
        user === null || user === void 0 ? void 0 : user.following
    ]);
    if (winner == null) {
        return null;
    }
    var _user_profileUrl;
    return /*#__PURE__*/ _jsxs(Modal, _object_spread_props(_object_spread({
        title: intl.formatMessage({
            id: "H+vBOj",
            defaultMessage: [
                {
                    type: 0,
                    value: "Winner"
                }
            ]
        }),
        cancelText: intl.formatMessage({
            id: "rbrahO",
            defaultMessage: [
                {
                    type: 0,
                    value: "Close"
                }
            ]
        }),
        isOpen: winner != null,
        onClose: onClose,
        size: "lg",
        centered: true
    }, props), {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: styles.modalTitle,
                children: [
                    /*#__PURE__*/ _jsx(Avatar, {
                        src: user === null || user === void 0 ? void 0 : user.avatar,
                        component: "a",
                        href: (_user_profileUrl = user === null || user === void 0 ? void 0 : user.profileUrl) !== null && _user_profileUrl !== void 0 ? _user_profileUrl : ''
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: styles.winnerInfo,
                        children: [
                            /*#__PURE__*/ _jsx(Title, {
                                size: "sm",
                                children: winner === null || winner === void 0 ? void 0 : winner.displayName
                            }),
                            /*#__PURE__*/ _jsx(Text, {
                                size: "sm",
                                className: styles.followingStatus,
                                children: followingStatus
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Tooltip, {
                        label: intl.formatMessage({
                            id: "QtTFb9",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Time taken to become active"
                                }
                            ]
                        }),
                        position: "top",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: classNames(styles.activeStatus, _define_property({}, styles.winnerActive, winnerIsActive)),
                            children: /*#__PURE__*/ _jsx(Text, {
                                children: dayjs().startOf('day').add(stopwatch, 'second').format('HH:mm:ss')
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Divider, {}),
            /*#__PURE__*/ _jsxs("div", {
                ref: ref,
                className: styles.winnerContainer,
                children: [
                    messages.length > 0 ? /*#__PURE__*/ _jsx("div", {
                        className: styles.winnerMessages,
                        children: _to_consumable_array(messages).concat(_to_consumable_array(priorMessages)).map(function(param) {
                            var message = param.message, messageId = param.messageId, date = param.date;
                            return /*#__PURE__*/ _jsxs("div", {
                                className: styles.message,
                                children: [
                                    /*#__PURE__*/ _jsx(Text, {
                                        className: styles.timestamp,
                                        size: "sm",
                                        children: dayjs(date).format('HH:mm:ss')
                                    }),
                                    /*#__PURE__*/ _jsx(Text, {
                                        className: styles.messageText,
                                        size: "sm",
                                        children: message
                                    })
                                ]
                            }, messageId);
                        })
                    }) : /*#__PURE__*/ _jsx("div", {
                        className: styles.waitingMessages,
                        children: /*#__PURE__*/ _jsx("div", {
                            className: styles.waitingMessagesNotice,
                            children: /*#__PURE__*/ _jsx(EmptyState, {
                                title: intl.formatMessage({
                                    id: "ApMPSg",
                                    defaultMessage: [
                                        {
                                            type: 0,
                                            value: "Winner Messages"
                                        }
                                    ]
                                }),
                                description: intl.formatMessage({
                                    id: "HPU9ip",
                                    defaultMessage: [
                                        {
                                            type: 0,
                                            value: "Waiting for winner to send a message"
                                        }
                                    ]
                                }),
                                icon: /*#__PURE__*/ _jsx(Loader, {
                                    type: "bars",
                                    size: LordIconSizes.SMALL
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx(MemoizedConfetti, {
                        width: width,
                        height: height,
                        recycle: false,
                        colors: colors
                    })
                ]
            })
        ]
    }));
}
export default GiveawayWinnerModal;
